/**
 * Traduce la URL al identificador que el menú lateral usa para marcar el
 * elemento activo. Es una derivación pura, no estado.
 *
 * Hace falta porque los elementos del menú de Almacén se identifican con dos
 * segmentos (`almacen/registro`) y la URL puede traer más
 * (`/almacen/registro/123/editar`).
 *
 * Vive aparte del layout para no romper el refresco en caliente: un archivo de
 * componentes no debe exportar además funciones sueltas.
 */
export const rutaActivaDeUrl = (pathname: string): string => {
  const limpio = pathname.replace(/^\//, '')
  if (limpio.startsWith('almacen/historial/')) {
    return limpio.split('/').slice(0, 3).join('/')
  }
  if (limpio.startsWith('almacen/')) {
    return limpio.split('/').slice(0, 2).join('/')
  }
  // Las pantallas de RH que cuelgan de `/rh/` se identifican igual que las de
  // almacén, con dos segmentos: `rh/validacion-direccion`. Con uno solo
  // quedaban todas en `rh`, que no es ningún elemento del menú, y entrar a
  // Cierre de selección o a Validación de Dirección no marcaba nada.
  if (limpio.startsWith('rh/')) {
    return limpio.split('/').slice(0, 2).join('/')
  }
  if (limpio.startsWith('hiring/candidates')) return 'hiring/candidates'
  return limpio.split('/')[0] || 'dashboard'
}
